var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-footer"},[_c('div',{staticClass:"bottom pa-4 f-column f-center"},[_c('p',{staticClass:"text-center text-caption mb-4"},[_vm._v("ADMINISTRATOR WEBSITE")]),_c('p',{staticClass:"ma-0 text-caption"},[_vm._v("Made by "),_c('strong',[_vm._v("HollowSTD ∀")]),_vm._v(" "+_vm._s(new Date().getFullYear()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }